import { useContext, useCallback } from "react";
import { CursorContext } from "../CursorContextProvider";
import isTouchDevice from "../utilities/isTouchDevice";
const useCursorHandlers = (options = {}) => {
  const [, setCursor] = useContext(CursorContext);
  const toggleCursor = () => {
    setCursor(({ active }) => ({ active: !active }));
  };
  const onMouseEnter = useCallback((event) => {
    if (options.onMouseEnter) {
      options.onMouseEnter(event);
    }
    toggleCursor();
  });
  const onMouseLeave = useCallback((event) => {
    if (options.onMouseLeave) {
      options.onMouseLeave(event);
    }
    toggleCursor();
  });
  if (isTouchDevice) {
    return options;
  } else {
    return { onMouseEnter, onMouseLeave };
  }
};

export default useCursorHandlers;
